// File: frontend/src/i18n/blog.js
// Version: 1.0 (2026-10-22)
// Description: словарь экрана «Блог» (EN/RU) и функция перевода.

const EN = {
    'blog.header.title': 'Blog Pipeline',
    'blog.header.subtitle': 'Articles published, queue status, and topic suggestions for fitenkolaw.com',
    'blog.status.pipeline_date': 'Pipeline data as of {date}',
    'blog.banner.stale': 'Pipeline has not sent data for over 24 hours — last received: {time}',
    'blog.banner.no_data': 'The pipeline has not sent any data yet',

    'blog.tabs.published': 'Published',
    'blog.tabs.pending': 'In Queue',
    'blog.tabs.suggestions': 'Topic Suggestions',

    'blog.published.filter_7d': '7 days',
    'blog.published.filter_30d': '30 days',
    'blog.published.filter_all': 'All days',
    'blog.published.count_7d': 'in last 7 days: {n}',
    'blog.published.count_total': 'total articles: {n}',
    'blog.published.col_date': 'Date',
    'blog.published.col_title': 'Title',
    'blog.published.col_category': 'Category',
    'blog.published.col_links': 'Links',
    'blog.published.col_verify': 'Verification',
    'blog.published.empty': 'No published articles found for the selected period',

    'blog.verify.ok': 'verified',
    'blog.verify.fail': 'check failed',
    'blog.verify.unverified': 'unverified',

    'blog.link.en': 'EN',
    'blog.link.ru': 'RU',

    'blog.pending.banner': 'Queue has {n} articles — scheduled through {date}',
    'blog.pending.banner_empty': 'No pending articles in queue',
    'blog.pending.col_pos': '#',
    'blog.pending.col_expected': 'Expected',
    'blog.pending.col_title': 'Title',
    'blog.pending.col_category': 'Category',
    'blog.pending.col_queue_id': 'Queue ID',
    'blog.pending.expected_label': 'expected {date}',
    'blog.pending.empty': 'The publishing queue is currently empty',

    'blog.suggestions.btn_propose': 'Propose Topic',
    'blog.suggestions.filter_all': 'All statuses',
    'blog.suggestions.filter_proposed': 'Proposed',
    'blog.suggestions.filter_accepted': 'Accepted',
    'blog.suggestions.filter_in_queue': 'In queue',
    'blog.suggestions.filter_published': 'Published',
    'blog.suggestions.filter_rejected': 'Rejected',
    'blog.suggestions.col_title': 'Topic',
    'blog.suggestions.col_keyword': 'Target Keyword',
    'blog.suggestions.col_priority': 'Priority',
    'blog.suggestions.col_language': 'Language',
    'blog.suggestions.col_status': 'Status',
    'blog.suggestions.col_queue_id': 'Queue ID',
    'blog.suggestions.col_actions': 'Actions',
    'blog.suggestions.empty': 'No topic suggestions found',

    'blog.status.proposed': 'Proposed',
    'blog.status.accepted': 'Accepted',
    'blog.status.in_queue': 'In queue',
    'blog.status.published': 'Published',
    'blog.status.rejected': 'Rejected',

    'blog.priority.high': 'High',
    'blog.priority.normal': 'Normal',
    'blog.priority.low': 'Low',

    'blog.language.both': 'EN + RU',
    'blog.language.en': 'EN only',
    'blog.language.ru': 'RU only',

    'blog.modal.title': 'Suggest a Blog Topic',
    'blog.modal.field_title': 'Title or Topic (required)',
    'blog.modal.field_keyword': 'Target Keyword (optional)',
    'blog.modal.field_language': 'Target Language',
    'blog.modal.field_priority': 'Priority',
    'blog.modal.field_notes': 'Notes or Details',
    'blog.modal.field_queue_id': 'Linked Queue ID (optional)',
    'blog.modal.btn_cancel': 'Cancel',
    'blog.modal.btn_submit': 'Save Topic',
    'blog.modal.submitting': 'Saving...',
    'blog.modal.error': 'Failed to save topic suggestion',

    'blog.action.accept': 'Accept',
    'blog.action.reject': 'Reject',
    'blog.action.edit': 'Edit',
    'blog.action.save': 'Save',
    'blog.action.cancel': 'Cancel',
};

const RU = {
    'blog.header.title': 'Конвейер блога',
    'blog.header.subtitle': 'Вышедшие статьи, состояние очереди и рекомендованные темы fitenkolaw.com',
    'blog.status.pipeline_date': 'Данные конвейера на {date}',
    'blog.banner.stale': 'Конвейер не присылал данные больше суток — последнее: {time}',
    'blog.banner.no_data': 'Конвейер ещё не присылал данные',

    'blog.tabs.published': 'Вышло',
    'blog.tabs.pending': 'В очереди',
    'blog.tabs.suggestions': 'Темы',

    'blog.published.filter_7d': '7 дней',
    'blog.published.filter_30d': '30 дней',
    'blog.published.filter_all': 'Все дни',
    'blog.published.count_7d': 'за 7 дней: {n}',
    'blog.published.count_total': 'всего статей: {n}',
    'blog.published.col_date': 'Дата',
    'blog.published.col_title': 'Заголовок',
    'blog.published.col_category': 'Категория',
    'blog.published.col_links': 'Ссылки',
    'blog.published.col_verify': 'Проверка',
    'blog.published.empty': 'Нет вышедших статей за выбранный период',

    'blog.verify.ok': 'проверено',
    'blog.verify.fail': 'сбой проверки',
    'blog.verify.unverified': 'не проверено',

    'blog.link.en': 'EN',
    'blog.link.ru': 'RU',

    'blog.pending.banner': 'В очереди {n} статей — хватит до {date}',
    'blog.pending.banner_empty': 'В очереди нет статей',
    'blog.pending.col_pos': '№',
    'blog.pending.col_expected': 'Ожидается',
    'blog.pending.col_title': 'Заголовок',
    'blog.pending.col_category': 'Категория',
    'blog.pending.col_queue_id': 'ID очереди',
    'blog.pending.expected_label': 'ожидается {date}',
    'blog.pending.empty': 'Очередь публикаций пуста',

    'blog.suggestions.btn_propose': 'Предложить тему',
    'blog.suggestions.filter_all': 'Все статусы',
    'blog.suggestions.filter_proposed': 'Предложены',
    'blog.suggestions.filter_accepted': 'Приняты',
    'blog.suggestions.filter_in_queue': 'В очереди',
    'blog.suggestions.filter_published': 'Вышли',
    'blog.suggestions.filter_rejected': 'Отклонены',
    'blog.suggestions.col_title': 'Тема',
    'blog.suggestions.col_keyword': 'Ключевое слово',
    'blog.suggestions.col_priority': 'Приоритет',
    'blog.suggestions.col_language': 'Язык',
    'blog.suggestions.col_status': 'Статус',
    'blog.suggestions.col_queue_id': 'ID очереди',
    'blog.suggestions.col_actions': 'Действия',
    'blog.suggestions.empty': 'Нет предложенных тем',

    'blog.status.proposed': 'Предложена',
    'blog.status.accepted': 'Принята',
    'blog.status.in_queue': 'В очереди',
    'blog.status.published': 'Вышла',
    'blog.status.rejected': 'Отклонена',

    'blog.priority.high': 'Высокий',
    'blog.priority.normal': 'Обычный',
    'blog.priority.low': 'Низкий',

    'blog.language.both': 'EN + RU',
    'blog.language.en': 'Только EN',
    'blog.language.ru': 'Только RU',

    'blog.modal.title': 'Предложить тему для блога',
    'blog.modal.field_title': 'Заголовок или тема (обязательно)',
    'blog.modal.field_keyword': 'Ключевое слово (необязательно)',
    'blog.modal.field_language': 'Язык статьи',
    'blog.modal.field_priority': 'Приоритет',
    'blog.modal.field_notes': 'Заметки или детали',
    'blog.modal.field_queue_id': 'Связь с элементом очереди (необязательно)',
    'blog.modal.btn_cancel': 'Отмена',
    'blog.modal.btn_submit': 'Сохранить тему',
    'blog.modal.submitting': 'Сохранение...',
    'blog.modal.error': 'Ошибка сохранения темы',

    'blog.action.accept': 'Принять',
    'blog.action.reject': 'Отклонить',
    'blog.action.edit': 'Редактировать',
    'blog.action.save': 'Сохранить',
    'blog.action.cancel': 'Отмена',
};

export const SLOVAR = Object.freeze({ en: Object.freeze(EN), ru: Object.freeze(RU) });

export function perevesti(lang, key, vars) {
    const slovar = SLOVAR[lang];
    if (!slovar || !Object.prototype.hasOwnProperty.call(slovar, key)) return `[${key}]`;
    const shablon = slovar[key];
    if (!vars || typeof vars !== 'object') return shablon;
    return shablon.replace(/\{([a-zA-Z_]+)\}/g, (celoe, imya) => (
        Object.prototype.hasOwnProperty.call(vars, imya) && vars[imya] !== undefined && vars[imya] !== null
            ? String(vars[imya])
            : celoe
    ));
}

export function raznitsaKlyuchey(a, b) {
    const vB = b || {};
    return Object.keys(a || {})
        .filter((k) => !Object.prototype.hasOwnProperty.call(vB, k))
        .sort();
}
